import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./en.json";
import esTranslation from "./es.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    es: {
      translation: esTranslation,
    },
  },
  lng: "en", // the default language
  fallbackLng: "en", // the fallback language if a translation is missing
  interpolation: {
    escapeValue: false, // allow interpolation of HTML tags
  },
});

export default i18n;
